import client from '/src/services/client.js';

export default {
    getDocuments: (call_id) => client.get(`calls/conversation/${call_id}/documents`),
    uploadDocument: (call_id, formData) => client.post(`calls/conversation/${call_id}/documents`, formData),
    deleteDocument: (call_id, documentId) => client.delete(`calls/conversation/${call_id}/documents/${documentId}`),
}
